import loadable from '@loadable/component';

import type { HotelsWithClosestDistanceProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/HotelsWithClosestDistanceProps';

const CardRailWithInventoryCard = loadable(
  () => import('../CardRailWithInventoryCard/CardRailWithInventoryCard'),
);

const HotelsWithClosestDistance = (props: HotelsWithClosestDistanceProps) => (
  <CardRailWithInventoryCard {...props} />
);

export default HotelsWithClosestDistance;
